import { FC, lazy } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import paths from '../../paths.json';

const Auth = lazy(() => import('../../routes/Auth'));
const Home = lazy(() => import('../../routes/Home'));
const Welcome = lazy(() => import('../../routes/Welcome'));
const Marketplace = lazy(() => import('../../routes/Marketplace'));

const legacyPaths = ['/partners', '/profiles', '/settings'];

const App: FC = () => {
  const { pathname } = useLocation();

  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
      <Route path={[paths.login, paths.changePassword, paths.resetPassword]}>
        <Welcome />
      </Route>
      <Route path={paths.auth}>
        <Auth />
      </Route>
      <Route path={[paths.company, paths.account]}>
        <Marketplace />
      </Route>
      {/* Pages of the former partners/profiles/settings areas */}
      <Route path={legacyPaths}>
        <Redirect to={paths.company} />
      </Route>
      <Route
        path={[
          paths.home,
          paths.register,
          paths.thankYou,
          paths.registrationReview,
        ]}
      >
        <Home />
      </Route>
    </Switch>
  );
};

App.displayName = 'App';

export default App;
